module.exports = __webpack_public_path__ + "img/cocoa-difference.5a3c27fc.png";